import { SvgIcon, SvgIconProps } from '@mui/material';
import { useRef } from 'react';

let nextId = 0;

/* eslint-disable-next-line */
export interface CcfNiceLyraLogoIconProps extends SvgIconProps {}

/**
 * Blue NICE logo icon for Lyra design (default state)
 * @param props - SvgIconProps
 * @example <CcfNiceLyraLogoIcon />
 * @returns
 */
export function CcfNiceLyraLogoIcon(props: CcfNiceLyraLogoIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7188 5.81445C23.8757 5.8146 24.0015 5.94038 24 6.0957C23.8494 15.8179 15.9182 23.6985 6.13379 23.8477C5.97839 23.8493 5.85077 23.7237 5.85059 23.5684V19.3086C5.85059 19.1563 5.97502 19.0335 6.12891 19.0303C13.2448 18.8844 19.0048 13.1599 19.1523 6.08984C19.1556 5.93599 19.2788 5.81255 19.4326 5.8125L23.7188 5.81445Z"
        fill="#3694FC"
      />
      <path
        d="M12.2559 0.000976562C13.8714 0.00104033 15.1804 1.30219 15.1807 2.90625C15.1807 4.51051 13.8716 5.81244 12.2559 5.8125C10.6401 5.8125 9.33008 4.51055 9.33008 2.90625C9.33031 1.30215 10.6402 0.000976562 12.2559 0.000976562Z"
        fill="#3694FC"
      />
      <path
        d="M2.92578 0C4.5412 0.000213196 5.85033 1.30132 5.85059 2.90527C5.85059 4.50944 4.54135 5.81131 2.92578 5.81152C1.31003 5.81152 0 4.50957 0 2.90527C0.000253194 1.30119 1.31018 0 2.92578 0Z"
        fill="#3694FC"
      />
    </SvgIcon>
  );
}

/**
 * Animated gradient NICE logo icon for Lyra design (hover state)
 * @param props - SvgIconProps
 * @example <CcfNiceLyraLogoGradientIcon />
 * @returns
 */
export function CcfNiceLyraLogoGradientIcon(props: CcfNiceLyraLogoIconProps) {
  const gradientIdRef = useRef(`niceLogoGrad-${nextId++}`);
  const gradientId = gradientIdRef.current;

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="27.015"
          y1="16.05"
          x2="-3.349"
          y2="5.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="0.166667" stopColor="#A855F7" />
          <stop offset="0.333333" stopColor="#EC4899" />
          <stop offset="0.5" stopColor="#F59E0B" />
          <stop offset="0.666667" stopColor="#10B981" />
          <stop offset="0.833333" stopColor="#3B82F6" />
          <stop offset="1" stopColor="#6366F1" />
          <animateTransform
            attributeName="gradientTransform"
            type="rotate"
            values="0 12 12;360 12 12"
            dur="4s"
            repeatCount="indefinite"
          />
        </linearGradient>
      </defs>
      <path
        d="M23.7188 5.81445C23.8757 5.8146 24.0015 5.94038 24 6.0957C23.8494 15.8179 15.9182 23.6985 6.13379 23.8477C5.97839 23.8493 5.85077 23.7237 5.85059 23.5684V19.3086C5.85059 19.1563 5.97502 19.0335 6.12891 19.0303C13.2448 18.8844 19.0048 13.1599 19.1523 6.08984C19.1556 5.93599 19.2788 5.81255 19.4326 5.8125L23.7188 5.81445Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M12.2559 0.000976562C13.8714 0.00104033 15.1804 1.30219 15.1807 2.90625C15.1807 4.51051 13.8716 5.81244 12.2559 5.8125C10.6401 5.8125 9.33008 4.51055 9.33008 2.90625C9.33031 1.30215 10.6402 0.000976562 12.2559 0.000976562Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M2.92578 0C4.5412 0.000213196 5.85033 1.30132 5.85059 2.90527C5.85059 4.50944 4.54135 5.81131 2.92578 5.81152C1.31003 5.81152 0 4.50957 0 2.90527C0.000253194 1.30119 1.31018 0 2.92578 0Z"
        fill={`url(#${gradientId})`}
      />
    </SvgIcon>
  );
}

export default CcfNiceLyraLogoIcon;
